<template>
  <UiModal
    ref="modal"
    :title="$t('modals.profile')"
    width="986px"
    :disabled="useUsuariosStore().status.update === 'loading'"
    :loading="useUsuariosStore().status.getById === 'loading'"
    :before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <ProfileContent
      v-if="isOpen"
      ref="profileForm"
    />

    <ModalChangePassword ref="modalChangePasswordRef" />

    <template #footer>
      <div
        v-if="useUsuariosStore().status.getById !== 'loading'"
        class=" flex justify-between text-right flex-wrap sm:space-x-2 space-y-2 sm:space-y-0"
      >
        <div class="flex flex-wrap items-center justify-end gap-2">
          <UiButton type="danger" class="h-12 px-4 text-sm uppercase" @click="resetPassword()">
            {{ $t('button.resetPassword') }}
          </UiButton>

          <UiButton type="primary" outline class="h-12 px-4 text-sm uppercase" @click="() => changePassword()">
            {{ $t('button.changePassword')}}
          </UiButton>
        </div>

        <div class="space-x-2">
          <UiButton type="danger" outline class="px-6 py-3 text-sm uppercase" :disabled="profileForm?.busy" @click="close()">
            {{ $t('button.cancel')}}
          </UiButton>
          <UiButton
            type="primary"
            class="px-6 py-3 text-sm uppercase"
            :disabled="useUsuariosStore().status.update === 'loading'"
            :loading="profileForm?.busy"
            @click="confirm()"
          >
            {{ $t('button.save') }}
          </UiButton>
        </div>
      </div>
    </template>
  </UiModal>
  <UiModal
    ref="loader"
    :title="$t('feedback.loading')"
    width="280px"
    disable-esc
    hide-close
    hide-footer
  >
    {{ $t('feedback.pleaseWait') }}
  </UiModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouteHash } from '@vueuse/router'
import { useAuthStore, useUsuariosStore } from '@/stores'

import UiButton from '@/components/ui/button.vue'
import UiModal from '@/components/ui/modal.vue'

import ProfileContent from './content.vue'
import ModalChangePassword from '@/components/modais/usuario/modalChangePassword.vue'

defineOptions({
  name: 'ProfileModal'
})

const modalChangePasswordRef = ref()
const hash = useRouteHash()

const auth = useAuthStore()
const modal = ref<InstanceType<typeof UiModal> | null>(null)
const loader = ref<InstanceType<typeof UiModal> | null>(null)
const profileForm = ref<InstanceType<typeof ProfileContent> | null>(null)
const isOpen = ref(false)

const beforeOpen = async () => {
  isOpen.value = false

  try {
    if (!auth.userData.id) {
      loader.value?.open()
      await auth.getUserInfo(auth.persistentInfo.id)
      loader.value?.cancel()
    }
  } catch (error) {
    loader.value?.cancel()
    return false
  }

  isOpen.value = true
  return true
}

const close = () => { modal.value?.cancel() }

const confirm = async () => {
  if (!await profileForm.value?.submit()) return

  close()
}

const resetPassword = async () => {
  await profileForm.value?.resetPassword()
}

const changePassword = async () => {
  await modalChangePasswordRef.value?.open({
    id: auth.userData.id,
    nomeCompleto: auth.userData.nomeCompleto,
    email: auth.userData.email,
    cpf: auth.userData.cpf
  })
}

const beforeClose = () => {
  if (hash.value === '#profile') hash.value = ''
}

defineExpose({
  open: () => modal.value?.open()
})
</script>
